import { Directive, ElementRef, Renderer2, Input, OnInit, HostListener } from '@angular/core';
import { NG_VALUE_ACCESSOR, DefaultValueAccessor } from '@angular/forms';
import { DateService } from '../common/date.service';
import { DateUtilsService } from '../common/date-utils.service';
import { FixDateService, FixDateConverter } from '../common/fixDate.service';
import { parseDateRange } from '../common/date-range-parser';

@Directive({
  selector: '[appFixDate]',
  providers: [
    { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: FixDateDirective }
  ]
})
export class FixDateDirective extends DefaultValueAccessor implements OnInit {
  @Input() appFixDate: string;
  @Input() unknownReplacement: string;

  private converter: FixDateConverter;

  constructor(
    renderer: Renderer2,
    elementRef: ElementRef,
    private dateService: DateService,
    private dateUtils: DateUtilsService,
    private fixDateService: FixDateService
  ) {
    super(renderer, elementRef, false);
  }

  ngOnInit(): void {
    const { from, to } = parseDateRange(
      this.appFixDate,
      this.dateService,
      this.dateUtils
    );

    this.converter = this.fixDateService.getConverter({
      preferredFrom: from,
      preferredTo: to,
      unknownReplacement: this.unknownReplacement,
    });
  }

  @HostListener('blur', ['$event'])
  onTextBlur(evt) {
    this.onInput(evt.target.value);
    this.onTouched();
  }

  writeValue(value: any): void {
    super.writeValue(this.transformValue(value));
  }

  onInput(value: any): void {
    const transformed = this.transformValue(value);
    super.writeValue(transformed);
    this.onChange(transformed);
  }

  transformValue(value: any): any {
    return this.converter.convert(value);
  }
}
